import React, { useEffect, useState } from "react";
import { useRouteMatch } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import List from "./components/List";
import AddWidgetComponent from "./components/AddWidget";

import { findWidgetsByApplication } from "../../pages/User/actions";
import { closeIframesScreens } from "~/containers/SidebarContainer/util";
import "../../assets/css/styles.css";

const WidgetContainer = ({ app, translations }) => {
  let { path } = useRouteMatch();
  const dispatch = useDispatch();
  const { menu } = useSelector((state) => state.applicationMenuReducer);
  const { user } = useSelector((state) => state.globalReducer);
  const {
    userWidgets,
    userSettings,
    lastAddedWidget,
    isUpdatedWidget,
    organizationCollection,
    organizationWidgets,
  } = useSelector((state) => state.userSettingsReducer);
  const [scopes, setScopes] = useState({});

  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    dispatch(findWidgetsByApplication(path, organizationCollection?.orgId));
  }, [
    dispatch,
    lastAddedWidget,
    userSettings,
    organizationCollection,
    isUpdatedWidget,
    path,
  ]);

  useEffect(() => {
    /*close full screen iframes*/
    closeIframesScreens();
  });

  const { configuration } = useSelector((state) => state.adminConfigReducer);
  const isProductionMode = configuration ? configuration.productionMode : true;

  const [isMobile, setIsMobile] = useState(
    window.innerWidth < 768 && configuration && configuration.mobileReady
  );
  //set initial states

  useEffect(() => {
    const handleResize = () =>
      setIsMobile(
        window.innerWidth < 768 && configuration && configuration.mobileReady
      );
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getWidgets = (widgets, dashboard) => {
    if (dashboard === undefined) return undefined;
    let newlists = [];
    if (isProductionMode) {
      dashboard.placements.map((list) => {
        let newlist = [];
        list.map((id) => {
          widgets.map((entity) => {
            if (entity.id === id) {
              if (entity.widget && entity.widget.production === true) {
                newlist.push(entity);
              }
            }
            return undefined;
          });
          return undefined;
        });
        newlists.push(newlist);
        return undefined;
      });
    } else {
      dashboard.placements.map((list) => {
        let newlist = [];
        list.map((id) => {
          widgets.map((entity) => {
            if (entity.id === id) {
              entity.widget &&
                entity.widget.production === true &&
                newlist.push(entity);
            }
            return undefined;
          });
          return undefined;
        });
        newlists.push(newlist);
        return undefined;
      });
    }
    return newlists;
  };
  const renderWidgets = (dashboards, widgetsSource, scope) => {
    if (!dashboards) return;

    const dashboard = dashboards.find((item) => item.application === path);
    const widgets = getWidgets(widgetsSource, dashboard);

    if (widgets) {
      widgets.forEach((list, listIndex) => {
        content.push(
          <List
            key={listIndex}
            listId={listIndex}
            widgets={list}
            app={app}
            translations={translations}
            scope={scope}
            isAdmin={isAdmin}
          />
        );
      });
    }
  };

  let content = [];
  if (scopes === "org") {
    renderWidgets(
      organizationCollection.dashboards,
      organizationWidgets,
      scopes
    );
  } else {
    renderWidgets(userSettings.dashboards, userWidgets, scopes);
  }

  useEffect(() => {
    if (user && user.roles && user.roles.some((r) => r.label === "ADMIN")) {
      setIsAdmin(true);
    } else setIsAdmin(false);
  }, [user]);

  useEffect(() => {
    if (menu) {
      let app = "";
      let arr2 = "";
      const arr1 =
        window.location.href.includes("/uniksystem/") &&
        window.location.href.split("/uniksystem/");
      if (arr1.length > 1) {
        arr2 = arr1[1];
        const arr3 = arr2.split("/");
        app = arr3[0];
      }
      const menuItem = menu.find((item) => item.route === arr2);
      if (menuItem) {
        const extraConfiguration_ = JSON.parse(
          menuItem.extraConfiguration || false
        );

        setScopes(extraConfiguration_?.scope);
      }
    }
  }, [
    menu,
    lastAddedWidget,
    userSettings,
    organizationCollection,
    isUpdatedWidget,
    path,
  ]);

  return (
    <>
      <div id="content-wrapper">
        {content}
        {(isAdmin || scopes !== "org") && (
          <AddWidgetComponent scope={scopes} isAdmin={isAdmin} />
        )}
      </div>
    </>
  );
};
export default WidgetContainer;
